import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _ProductionResource, _WelfareEntity } from '../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../theme/Component/usePaginator';
import { WelfareEntityincapacities } from '../ParametrosTalentoHumano/ImportedPayrollBeneficiary/WelfareEntityincapacities';
import { WelfareEntityTypeEditor } from '../ParametrosTalentoHumano/EmployeeBonus/Editors/WelfareEntityType.Editor';
import { BasicButton } from '../../theme/Component/BasicButton';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const WelfareEntityEditorTable = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {
    const paginador = usePaginator();
    const [contanst, setconstansts] = useState<any>(null)
    const [tipe, settipe] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const { instance, lista, setLista } = useDataBean(_ProductionResource)
    const [id, setID] = useState(null);
    const welfareentity = useDataBean(_WelfareEntity);
    const modal = useModal("Entidades de Seguridad Social", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    // useEffect(() => {
    //     getLista();
    // }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDWelfareEntity == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        welfareentity.instance.getWelfareEntityCatalogByType(contanst, tipe, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {

                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    // setLista(resp.List)

                    let x = resp.List;
                    x.forEach((item) => {
                        item.DataBeanProperties.Coderender = (item.DataBeanProperties.Code ?? "") + " - " + (item.DataBeanProperties.AccountName ?? "")
                    });
                    setLista(x)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDWelfareEntity', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'Type', visible: true },
        { title: 'Tipo de Entidad', property: 'WelfareEntityTypeName', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Utiliza Presupuesto', property: 'ApplyBudget', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Utilizar Cuenta Contable', property: 'AccountantIDStrName', visible: true },
        { title: 'Frecuencia de Pago', property: 'PaymentFrecuency', visible: true },
        { title: 'Fabrica de Reportador', property: 'ClassFileFactory', visible: true },
        { title: 'Ubicación Geográfica', property: 'SiteIDName', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Entidades de Seguridad Social"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <WelfareEntityincapacities label='Tipo' idSelector={contanst} onChange={(e) => { setconstansts(e) }} />
                    </div>
                    <div className="col-md-4">
                        <WelfareEntityTypeEditor idSelector={tipe} onChange={(e) => { settipe(e) }} label="Tipo de Entidad" />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton value="Buscar por Filtros*" icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDWelfareEntity); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}